var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"draggable-item"},[_c('div',{staticClass:"handle"},[_vm._t("handle",function(){return [_c('XWikiIcon',{attrs:{"icon-descriptor":{name: 'menu'}}})]})],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }